<!-- ImageView.vue -->
<template>
  <img ref="img" :src="currentSrc" :alt="alt" @error="onError" class="image-view" />
</template>

<script setup>
import { ref, onMounted, onUpdated, watch } from 'vue'
import Column from './Column.vue' // 修正后的导入路径

const props = defineProps({
  url: {
    type: String,
    default: null,
  },
  alt: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['error'])

const img = ref(null)
const urlFailed = new URL('@/assets/place_holder.png', import.meta.url).href

const currentSrc = ref('') // 当前图片的 src

function onError() {
  if (img.value) {
    currentSrc.value = urlFailed
  }
}

const loadedInfo = {
  loaded: false,
  observed: false,
}

// 懒加载
const ob = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting && !loadedInfo.loaded) {
      currentSrc.value = props.url
      loadedInfo.loaded = true
      ob.unobserve(entry.target)
    }
  })
})

function observerAva() {
  if (props.url && !loadedInfo.loaded && !loadedInfo.observed) {
    ob.observe(img.value)
    loadedInfo.observed = true
  }
}

onMounted(() => {
  observerAva()
})

onUpdated(() => {
  observerAva()
})

watch(
  () => props.url,
  newUrl => {
    if (newUrl) {
      loadedInfo.loaded = false
      loadedInfo.observed = false
      currentSrc.value = '' // 重置 src
      ob.observe(img.value)
    }
  }
)
</script>

<style scoped>
.image-view {
  object-fit: contain;
  width: 100%;
  height: auto;
  padding: 12px;
  transition: opacity 0.3s;
  opacity: 0;
}

.image-view[src] {
  opacity: 1;
}
</style>
